<template>
    <div class="obrigatorio">
        <label class="switch-wrapper" :class="{ unchecked: !checked }" for="ob-checkbox">
            <!--
                @69953 - v-model="checked" -> alterado para :checked:"checked"
                Parar de dar erro no console referente a alterar o valor do componente
                de forma direta
            -->
            <input
                type="checkbox"
                :checked="checked"
                @focus="focus($event)"
                :value="value"
                @change="onChange($event, value)"
                :ref="value"
                :disabled="disabled"
            />
            <div class="switch">
                <svg class="svg-icons" :class="{ show: checked }">
                    <use :xlink:href="require('@/assets/img/icons/check.svg') + '#layer'"></use>
                </svg>
                <svg class="svg-icons" :class="{ show: !checked }">
                    <use :xlink:href="require('@/assets/img/icons/close.svg') + '#layer'"></use>
                </svg>
            </div>
        </label>
        <p>{{ text }}</p>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            default: '',
        },
        checked: {
            default: false,
        },
        value: {
            default: new Date().getTime(),
        },
        onChange: {
            type: Function,
            default: function (e, val) {
                this.$emit('change', e.target.checked);
            },
        },
        focus: {
            type: Function,
            default: function (e) {
                this.$emit('focus', e.target.checked);
            },
        },
        disabled: {
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/../styles.scss';

.obrigatorio {
    display: flex;
    align-items: center;
    margin-left: 10px;

    > .switch-wrapper {
        margin-bottom: 0;
        position: relative;

        > input {
            opacity: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
            cursor: pointer;
        }

        > .switch {
            top: 3px;
            height: 24px;
            width: 51px;
            position: relative;
            background: $primary-color;
            border-radius: 50px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            cursor: pointer;
            transition: 0.2s linear;

            &::after {
                content: '';
                height: 15px;
                width: 15px;
                border-radius: 100px;
                display: block;
                transition: 0.15s linear;
                background: $light-gray-color;
                position: absolute;
                left: 97%;
                margin-left: -18px;
                cursor: pointer;
                top: 4px;
                box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
            }

            svg {
                fill: $sovis-white;
                width: 16px;
                height: 16px;
            }

            svg:nth-child(1) {
                position: absolute;
                left: 6px;
                transition: 0.2s linear;
                opacity: 0;
            }

            svg:nth-child(2) {
                position: absolute;
                right: 6px;
                transition: 0.2s linear;
                opacity: 0;
            }

            svg.show {
                opacity: 1;
            }
        }

        &.unchecked .switch {
            background: $darker-gray-color;
            &::after {
                background-color: $light-gray-color;
                left: 23px;
            }
        }
    }

    > p {
        margin-bottom: 0 !important;
        margin-left: 10px;
        font-weight: 600;
        font-size: 14px;
        color: $darker-gray-color;
    }
}

.days-of-week {
    > .obrigatorio {
        flex-direction: column-reverse;

        p {
            text-align: center;
            margin-bottom: 5px !important;
        }
    }

    .switch {
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 10px;
    }
}
</style>
